import React, { useEffect, useState } from "react";

const EnvironmentIndicator = ({ inline = false }) => {
  const [envText, setEnvText] = useState("");
  const [colors, setColors] = useState({ bgColor: "", textColor: "", borderColor: "", dotColor: "" });
  const [hasHeader, setHasHeader] = useState(false);

  useEffect(() => {
    const hostname = window.location.hostname;
    
    if (hostname.includes("staging.conserve.com.au")) {
      setEnvText("Conserve V3 – Staging");
      setColors({
        bgColor: "#fffbeb", // amber-50
        textColor: "#b45309", // amber-700
        borderColor: "#fde68a", // amber-200
        dotColor: "#f59e0b" // amber-500
      });
    } else if (hostname.includes("functionality.conserve.com.au")) {
      setEnvText("Conserve V3 – Functionality");
      setColors({
        bgColor: "#eff6ff", // blue-50
        textColor: "#1d4ed8", // blue-700
        borderColor: "#bfdbfe", // blue-200
        dotColor: "#3b82f6" // blue-500
      });
    } else if (
      hostname.includes("localhost") || 
      hostname.includes("127.0.0.1") || 
      window.location.port === "3000" || 
      window.location.port === "3001" || 
      window.location.port === "37621"
    ) {
      setEnvText("Conserve V3 – Local");
      setColors({
        bgColor: "#f0fdfa", // teal-50
        textColor: "#0f766e", // teal-700
        borderColor: "#99f6e4", // teal-200
        dotColor: "#0d9488" // teal-600
      });
    }
  }, []);

  useEffect(() => {
    if (inline) return;

    const checkHeader = () => {
      const headerEl = document.querySelector("header.header");
      setHasHeader(!!headerEl);
    };

    checkHeader();
    
    const observer = new MutationObserver(checkHeader);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [inline]);

  if (!envText) return null;

  if (!inline && hasHeader) return null;

  if (inline) {
    return (
      <div 
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          padding: "6px 12px",
          borderRadius: "20px",
          backgroundColor: colors.bgColor,
          color: colors.textColor,
          border: `1px solid ${colors.borderColor}`,
          fontSize: "11px",
          fontWeight: "600",
          fontFamily: "Inter, system-ui, sans-serif",
          userSelect: "none",
          marginRight: "16px"
        }}
      >
        <span 
          style={{
            width: "6px",
            height: "6px",
            borderRadius: "50%",
            backgroundColor: colors.dotColor,
            display: "inline-block"
          }}
        />
        {envText}
      </div>
    );
  }

  return (
    <div 
      style={{
        position: "fixed",
        top: "16px",
        right: "24px",
        zIndex: 999999,
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        gap: "6px",
        padding: "6px 12px",
        borderRadius: "20px",
        backgroundColor: colors.bgColor,
        color: colors.textColor,
        border: `1px solid ${colors.borderColor}`,
        fontSize: "11px",
        fontWeight: "600",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
        fontFamily: "Inter, system-ui, sans-serif",
        userSelect: "none"
      }}
    >
      <span 
        style={{
          width: "6px",
          height: "6px",
          borderRadius: "50%",
          backgroundColor: colors.dotColor,
          display: "inline-block"
        }}
      />
      {envText}
    </div>
  );
};

export default EnvironmentIndicator;
